let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Wi43")).then(() => parcelRequire('aoN9y'));